var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHvac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13346 11.667H12.8751C13.0918 11.292 13.2418 10.867 13.3001 10.417H6.7168C6.7668 10.867 6.90846 11.292 7.13346 11.667Z",
    fill: "#1A2A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 13.3333C10.8414 13.3333 11.5914 13.0083 12.1831 12.5H7.81641C8.40807 13.0083 9.15807 13.3333 9.99974 13.3333Z",
    fill: "#1A2A55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 6.66699C9.15807 6.66699 8.40807 6.99199 7.81641 7.50033H12.1831C11.5914 6.99199 10.8414 6.66699 9.99974 6.66699Z",
    fill: "#1A2A55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13398 8.33301C6.91732 8.70801 6.76732 9.13301 6.70898 9.58301H13.2923C13.234 9.13301 13.0923 8.70801 12.8673 8.33301H7.13398Z",
    fill: "#1A2A55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V17.5H17.5V2.5H2.5ZM10 15C7.24167 15 5 12.7583 5 10C5 7.24167 7.24167 5 10 5C12.7583 5 15 7.24167 15 10C15 12.7583 12.7583 15 10 15Z",
    fill: "#1A2A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/hvac.2ed4d60ff0d204b0dab1c90c4c8530f1.svg";
export { ForwardRef as ReactComponent };